export const whiskyBrands = {
  aberfeldy: "Aberfeldy",
  aberlour: "Aberlour",
  adelphi: "Adelphi",
  ailsa_bay: "Ailsa Bay",
  akashi: "Akashi",
  alex_ferguson: "Alex Ferguson",
  allt_a_bhanne: "Allt-A-Bhanne",
  ancnoc: "Ancnoc",
  angels_nectar: "Angels' Nectar",
  antiquary: "Antiquary",
  arbikie: "Arbikie",
  ardbeg: "Ardbeg",
  ardmore: "Ardmore",
  ardnamurchan: "Ardnamurchan",
  arran: "Arran",
  auchentoshan: "Auchentoshan",
  auchroisk: "Auchroisk",
  auld_alliance: "Auld Alliance",
  aultmore: "Aultmore",
  balblair: "Balblair",
  ballantines: "Ballantines",
  ballechin: "Ballechin",
  balmenach: "Balmenach",
  banff: "Banff",
  bank_note: "Bank Note",
  baxters: "Baxters",
  bells: "Bells",
  ben_nevis: "Ben Nevis",
  ben_wyvis: "Ben Wyvis",
  benriach: "Benriach",
  benrinnes: "Benrinnes",
  benromach: "Benromach",
  berry_bros_rudd: "Berry Bros & Rudd",
  big_peat: "Big Peat",
  black_white: "Black & White",
  black_bottle: "Black Bottle",
  bladnoch: "Bladnoch",
  blair_athol: "Blair Athol",
  blooming_gorse: "Blooming Gorse",
  bowmore: "Bowmore",
  braes_of_glenlivet: "Braes of Glenlivet (Braeval)",
  brora: "Brora",
  brown_derby: "Brown Derby",
  bruichladdich: "Bruichladdich",
  buchanans: "Buchanan's",
  buffalo_trace: "Buffalo Trace",
  bulloch_lade: "Bulloch Lade",
  bunnahabhain: "Bunnahabhain",
  bushmills: "Bushmills",
  caledonian: "Caledonian",
  cambus: "Cambus",
  cameronbridge: "Cameronbridge",
  caol_ila: "Caol Ila",
  caperdonich: "Caperdonich",
  cardhu: "Cardhu",
  carsebridge: "Carsebridge",
  catto: "Catto",
  chichibu: "Chichibu",
  chivas: "Chivas",
  chivas_regal: "Chivas Regal",
  clynelish: "Clynelish",
  coleburn: "Coleburn",
  collection_moon: "Collection Moon",
  collectivum: "Collectivum",
  compass_box: "Compass Box",
  connemara: "Connemara",
  convalmore: "Convalmore",
  copper_dog: "Copper Dog",
  copper_pot: "Copper Pot",
  crabbie: "Crabbie",
  cragganmore: "Cragganmore",
  craig_athol: "Craig Athol",
  craigduff: "Craigduff",
  craigellachie: "Craigellachie",
  crawfords: "Crawfords",
  croftengea: "Croftengea",
  cu_bogan: "Cu Bogan",
  cutty_sark: "Cutty Sark",
  dailuaine: "Dailuaine",
  dallas_dhu: "Dallas Dhu",
  dalmore: "Dalmore",
  dalwhinnie: "Dalwhinnie",
  dan_macfarlanes: "Dan Macfarlanes",
  dawsons: "Dawsons",
  deanston: "Deanston",
  deveron: "Deveron",
  dew_of_ben_nevis: "Dew of Ben Nevis",
  dewars: "Dewars",
  dimple: "Dimple",
  dufftown: "Dufftown",
  dumbarton: "Dumbarton",
  dunglass: "Dunglass",
  edradour: "Edradour",
  elements_islay: "Elements of Islay",
  epicurean: "Epicurean",
  famous_grouse: "Famous Grouse",
  fettercairn: "Fettercairn",
  findlaters: "Findlaters",
  flaming_feast: "Flaming Feast",
  fleet_street: "Fleet Street",
  four_roses: "Four Roses",
  gilbeys: "Gilbeys",
  gilmour_thomsons: "Gilmour Thomsons",
  girvan: "Girvan",
  gladstone_axe: "Gladstone Axe",
  glasshouse: "Glasshouse",
  glen_albyn: "Glen Albyn",
  glen_deveron: "Glen Deveron",
  glen_elgin: "Glen Elgin",
  glen_flagler: "Glen Flagler",
  glen_garioch: "Glen Garioch",
  glen_garry: "Glen Garry",
  glen_grant: "Glen Grant",
  glen_keith: "Glen Keith",
  glen_more: "Glen Mhor",
  glen_moray: "Glen Moray",
  glen_ord: "Glen Ord",
  glen_scotia: "Glen Scotia",
  glen_spey: "Glen Spey",
  glenallachie: "Glenallachie",
  glenborrodale: "Glenborrodale",
  glenburgie: "Glenburgie",
  glencadam: "Glencadam",
  glencoe: "Glencoe",
  glencraig: "Glencraig",
  glendronach: "Glendronach",
  glendullan: "Glendullan",
  glenesk: "Glenesk",
  glenfarclas: "Glenfarclas",
  glenfiddich: "Glenfiddich",
  glenfyne: "Glenfyne",
  glenglassauch: "Glenglassauch",
  glengoyne: "Glengoyne",
  glenkinchie: "Glenkinchie",
  glenlivet: "Glenlivet",
  glenlochy: "Glenlochy",
  glenlossie: "Glenlossie",
  glenmorangie: "Glenmorangie",
  glenrosa: "Glenrosa",
  glenrothes: "Glenrothes",
  glensia: "Glensia",
  glentauchers: "Glentauchers",
  glenturret: "Glenturret",
  glenugie: "Glenugie",
  glenury_royal: "Glenury Royal",
  grand_coronation: "Grand Coronation",
  grants: "Grants",
  green_spot: "Green Spot",
  haig: "Haig",
  hakushu: "Hakushu",
  hankey_bannister: "Hankey Bannister",
  hanyu: "Hanyu",
  harrods: "Harrods",
  harveys: "Harveys",
  hatozaki: "Hatozaki",
  hazelburn: "Hazelburn",
  hazelwood: "Hazelwood",
  heather_dew: "Heather Dew",
  hector_macbeth: "Hector Macbeth",
  highland_harvest: "Highland Harvest",
  highland_park: "Highland Park",
  hillside: "Hillside",
  house_of_lords: "House of Lords",
  huntly_royal: "Huntly Royal",
  ichiro: "Ichiro",
  imperial: "Imperial",
  inchfad: "Inchfad",
  inchgower: "Inchgower",
  inchmoan: "Inchmoan",
  inchmurrin: "Inchmurrin",
  inverleven: "Inverleven",
  islay_mist: "Islay Mist",
  isle_of_raasay: "Isle of Raasay",
  jg_stewart: "J & G Stewart",
  jb: "J&B",
  jameson: "Jameson",
  jim_beam: "Jim Beam",
  john_begg: "John Begg",
  john_dunbar: "John Dunbar",
  john_haigs: "John Haigs",
  john_ogroats: "John O'Groats",
  john_walker: "John Walker",
  johnnie_walker: "Johnnie Walker",
  jura: "Jura",
  kaiyo: "Kaiyo",
  karuizawa: "Karuizawa",
  kilchoman: "Kilchoman",
  kinclaith: "Kinclaith",
  king_george: "King George IV",
  king_william: "King William",
  kings_ransom: "King's Ransom",
  kingsbarns: "Kingsbarns",
  kininvie: "Kininvie",
  knob_creek: "Knob Creek",
  knockando: "Knockando",
  lagavulin: "Lagavulin",
  laphroaig: "Laphroaig",
  last_drop: "Last Drop",
  lauders: "Lauder's",
  ledaig: "Ledaig",
  lindores_abbey: "Lindores Abbey",
  linkwood: "Linkwood",
  linlithgow: "Linlithgow",
  littlemill: "Littlemill",
  loch_dhu: "Loch Dhu",
  loch_lomond: "Loch Lomond",
  lochnidaal: "Lochnidaal",
  lochside: "Lochside",
  logmorn: "Logmorn",
  long_john: "Long John",
  longrow: "Longrow",
  lord_elcho: "Lord Elcho",
  macnamara: "MacNaMara",
  macduff: "Macduff",
  makers_mark: "Makers Mark",
  mannochmore: "Mannochmore",
  middleton: "Middleton",
  millburn: "Millburn",
  miltonduff: "Miltonduff",
  mitchells_butlers: "Mitchells & Butlers",
  monarch_of_the_highlands: "Monarch of The Highlands",
  monkey_shoulder: "Monkey Shoulder",
  mortlach: "Mortlach",
  mortons: "Morton's",
  mossburn: "Mossburn",
  mosstowie: "Mosstowie",
  naked_grouse: "Naked Malt",
  ncnean: "Nc'nean",
  neals: "Neal's",
  nectar_grove: "Nectar Grove",
  nikka: "Nikka",
  nomad: "Nomad",
  north_british: "North British",
  north_port: "North Port",
  north_scotland: "North of Scotland",
  oban: "Oban",
  octomore: "Octomore",
  old_ballantruan: "Old Ballantruan",
  old_bannockburn: "Old Bannockburn",
  old_elgin: "Old Elgin",
  old_parr: "Old Parr",
  old_perth: "Old Perth",
  old_pultneey: "Old Pultneey",
  old_rarity: "Old Rarity",
  old_smuggler: "Old Smuggler",
  orbital: "Orbital",
  paddy: "Paddy",
  peat_chimney: "Peat Chimney",
  pigs_nose: "Pig's Nose",
  pinwinnie: "Pinwinnie",
  pittyvaich: "Pittyvaich",
  poit_dhubh: "Poit Dhub",
  port_askaig: "Port Askaig",
  port_charlotte: "Port Charlotte",
  port_dundas: "Port Dundas",
  port_ellen: "Port Ellen",
  pride_of_strathspey: "Pride of Strathspey",
  pure_scot: "Pure Scot",
  putachieside: "Putachieside",
  queen_anne: "Queen Anne",
  redbreast: "Redbreast",
  robert_burns: "Robert Burns (Arran)",
  rock_island: "Rock Island",
  rosebank: "Rosebank",
  royal_brackla: "Royal Brackla",
  royal_household: "Royal Household",
  royal_lochnagar: "Royal Lochnagar",
  royal_salute: "Royal Salute",
  sample_room: "Sample Room",
  samuel_webster_sons: "Samuel Webster & Sons.",
  sandersons: "Sanderson's",
  sandy_macdonald: "Sandy Macdonald",
  sandy_macnabs: "Sandy Macnab's",
  savoy: "Savoy",
  scallywag: "Scallywag",
  scapa: "Scapa",
  scotlands_ripe: "Scotland's Ripe Old Age",
  scots_bard: "Scots Bard",
  seagram: "Seagram",
  serendipity: "Serendipity",
  shackleton: "Shackleton",
  sheep_dip: "Sheep Dip",
  singleton: "Singleton",
  singleton_of_dufftown: "Singleton of Dufftown",
  six_isles: "Six Isles",
  smokehead: "Smokehead",
  smokey_joe: "Smokey Joe",
  something_special: "Something Special",
  spey_cast: "Spey Cast",
  spey_royal: "Spey Royal",
  speyburn: "Speyburn",
  speyside: "Speyside",
  spice_king: "Spice King",
  springbank: "Springbank",
  st_magdalene: "St Magdalene",
  stewarts: "Stewart's",
  strathclyde: "Strathclyde",
  strathcolm: "Strathcolm",
  strathconon: "Strathconon",
  strathisla: "Strathisla",
  strathmill: "Strathmill",
  suntory: "Suntory",
  talisker: "Talisker",
  tamdhu: "Tamdhu",
  tamnavulin: "Tamnavulin",
  teachers: "Teacher's",
  teaninich: "Teaninich",
  teeling: "Teeling",
  boutiquey: "That Boutique-y Whisky Company",
  the_balvenie: "The Balvenie",
  the_chita: "The Chita",
  the_exceptional: "The Exceptional",
  the_gauldrons: "The Gauldrons",
  the_hive: "The Hive",
  the_irishman: "The Irishman",
  the_junior: "The Junior",
  the_woodsman: "The Woodsman",
  timorous_beastie: "Timorous Beastie",
  tobermory: "Tobermory",
  togouchi: "Togouchi",
  tomatic: "Tomatic",
  tomintoul: "Tomintoul",
  tormore: "Tormore",
  tullamore: "Tullamore",
  tullibardine: "Tullibardine",
  tweeddale: "Tweeddale",
  te_bheag: "Té Bheag",
  uam_var: "Uam Var",
  various: "Various",
  vat_69: "Vat 69",
  whisky_works: "Whisky Works",
  white_horse: "White Horse",
  whyte_mackay: "Whyte & Mackay",
  william_grant: "William Grant",
  williamson: "Williamson",
  wolfburn: "Wolfburn",
  woodford_reserve: "Woodford Reserve",
  write_greigs: "Write & Greigs",
  writers: "Writers",
  yamazaki: "Yamazaki",
  olde_drury: "Ye Olde Drury",
  yellow_spot: "Yellow Spot",
  yoichi: "Yoichi",
};
